// Phase I5.1 — direction-preference helpers.
//
// The Daily Acca and Super Acca pages each support three render
// directions (A / B / C). User preference is persisted per-device under
// localStorage so the toggle survives reloads but does not require an
// authenticated round-trip.
//
// Doctrine: never throw. SSR / disabled storage / corrupt values all
// fall back to "A" (the canonical surface).

export type Direction = "A" | "B" | "C";

export const DAILY_ACCA_DIRECTION_KEY = "strikza:dailyacca:direction";
export const SUPER_ACCA_DIRECTION_KEY = "strikza:superacca:direction";

export function normalizeDirection(value: unknown): Direction {
  if (value === "A" || value === "B" || value === "C") return value;
  return "A";
}

export function getDirectionPreference(key: string): Direction {
  if (typeof window === "undefined") return "A";
  try {
    const v = window.localStorage.getItem(key);
    return normalizeDirection(v);
  } catch {
    return "A";
  }
}

export function setDirectionPreference(key: string, direction: Direction): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, direction);
  } catch {
    /* storage blocked — silent */
  }
}
